import { Link } from "react-router-dom";

// Logo ASTROLOG — monogramme « A » évoquant une trajectoire / une étoile
export const LogoMark = ({ size = 36 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    role="img"
    aria-label="Logo ASTROLOG"
    className="shrink-0"
  >
    <rect width="64" height="64" rx="14" fill="#0A0E1A" />
    <path
      d="M18 46 L32 16 L46 46"
      fill="none"
      stroke="#F97316"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M24 36 H40" stroke="#06B6D4" strokeWidth="5" strokeLinecap="round" />
    <circle cx="32" cy="16" r="4" fill="#FAFAF7" />
  </svg>
);

const Logo = ({ dark = false }) => (
  <Link
    to="/"
    data-testid="logo-link"
    className="flex items-center gap-3 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
    aria-label="ASTROLOG — retour à l'accueil"
  >
    <LogoMark />
    <span
      className={`font-heading text-xl font-bold tracking-tight ${
        dark ? "text-[#FAFAF7]" : "text-foreground"
      }`}
    >
      ASTRO<span className="text-accent">LOG</span>
    </span>
  </Link>
);

export default Logo;
